import React from "react";
import Typical from "react-typical";

import "./Profile.css";

const Profile = () => {
  const toContact = () => {
    window.open("mailto: laushaowei@gmail.com");
  };
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'M <span className="highlighted-text name">ShaoWei</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Software Engineer 💻",
                    1000,
                    "Full-Stack Developer 🎯",
                    1000,
                  ]}
                />
              </h1>
              <span className="profile-role-tagline">
                “Optimistic vision, pessimistic plan, happy execution.”{" "}
                <div>— Kazuo Inamori</div>
              </span>
            </span>
          </div>
          <div className="profile-options">
            <button onClick={toContact} className="btn primary-btn">
              Hire Me
            </button>
            <a href="SW's CV.pdf" download="SW's CV.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
